import React from "react";
import { MicroscopeIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { images } from "../../data/landing";
export function Hero() {
  return <header className="bg-cream px-4 pb-14 pt-6 sm:pt-10" data-id="element-154" data-mp="cut8xuewjh3a">
      <div className="mx-auto max-w-5xl text-center" data-id="element-155" data-mp="huxu3xqr8zzu">
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-156" data-mp="hwinhk1c2cw4">
          <span className="flex items-center gap-2" data-id="element-157" data-mp="mutuln08u9an">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-navy text-sky" data-id="element-158" data-mp="ms7prv4qm7w4">
              <MicroscopeIcon className="h-5 w-5" aria-hidden="true" data-id="element-159" data-mp="qt9hzs08ljol" />
            </span>
            <span className="font-display text-lg font-bold text-navy" data-id="element-160" data-mp="vofbbbvyy0mp">Liposuction Case Lab™</span>
          </span>
          <span className="rounded-full border border-navy/15 bg-white px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-skydeep" data-id="element-161" data-mp="15kidghqtlz9n">
            By Dr. Michael Carter
          </span>
        </div>

        <h1 className="mt-6 font-display text-[34px] font-extrabold leading-[1.08] text-navy sm:text-5xl md:text-6xl" data-id="element-162" data-mp="9nswfo0ko1cm">
          Analyze any liposuction case in{" "}
          <em className="italic text-skydeep" data-id="element-163" data-mp="4neqcbij71h8">15 minutes</em>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-ink/75 sm:text-xl" data-id="element-164" data-mp="3vvskx1nwkdi1">
          A case-based professional training system to help plastic surgeons and aesthetic physicians analyze cases with structure, identify the key variables and organize their preoperative thinking. Includes{" "}
          <strong className="text-navy" data-id="element-165" data-mp="nfr1nnr5xd3i">6 volumes</strong>, <strong className="text-navy" data-id="element-166" data-mp="io91v30vlik4">5 bonuses</strong> and{" "}
          <strong className="text-navy" data-id="element-167" data-mp="imed1dmhh6ar">30+ case review tools</strong>.
        </p>

        <img src={images.mockup} alt="Liposuction Case Lab™ — 6 volumes, 5 bonuses and case review tools" className="mx-auto mt-6 w-full max-w-3xl" data-id="element-168" data-mp="emdy7rvh2t36" />

        <div className="mt-4" data-id="element-169" data-mp="16da58buuq3ij">
          <CTAButton id="first-cta" label="I want the Liposuction Case Lab™" caption="Instant digital access · One-time payment of $27 · Lifetime access · 7-day guarantee" data-id="element-170" data-mp="16c8pvv6syuv0" />
          <Countdown data-id="element-171" data-mp="2qwdud37hef1b" />
        </div>
      </div>
    </header>;
}